const responsiblePartyItems = {
    'srg': 'SRG',
    'client': 'Client',
    'broker_dealer': 'Broker Dealer',
    'custodian': 'Custodian',
    'accountant': 'Accountant',
    'attorney': 'Attorney',
    'other': 'Other',
    'not_applicable': 'Not Applicable'
};

const durationItems = {
    "0.25": "00:15",
    "0.50": "00:30",
    "0.75": "00:45",
    "1.00": "01:00",
    "1.25": "01:15",
    "1.50": "01:30",
    "1.75": "01:45",
    "2.00": "02:00",
    "2.25": "02:15",
    "2.50": "02:30",
    "2.75": "02:45",
    "3.00": "03:00",
    "3.25": "03:15",
    "3.50": "03:30",
    "3.75": "03:45",
    "4.00": "04:00",
    "4.25": "04:15",
    "4.50": "04:30",
    "4.75": "04:45",
    "5.00": "05:00",
    "5.25": "05:15",
    "5.50": "05:30",
    "5.75": "05:45",
    "6.00": "06:00",
    "6.25": "06:15",
    "6.50": "06:30",
    "6.75": "06:45",
    "7.00": "07:00",
    "7.25": "07:15",
    "7.50": "07:30",
    "7.75": "07:45",
    "8.00": "08:00",
    "8.25": "08:15",
    "8.50": "08:30",
    "8.75": "08:45",
    "9.00": "09:00",
    "9.25": "09:15",
    "9.50": "09:30",
    "9.75": "09:45",
    "10.00": "10:00"
}

const ownerItems = {
    '27a977e6-9280-4b48-a763-4aaf5a5ad542': 'Cliff Weiler',
    'becb0705-1ab6-4bf1-8525-318d88b14dd4': 'Aliza Perry',
    '1bcd541c-5202-41eb-a784-f65af3fedd6d': 'Courtney Sobkow',
    '3c8e3f80-934a-4553-92a1-37a411ab4de2': 'David Grau Jr',
    'be64ad88-66fb-43f5-b15d-db0572322bbc': 'David Mueller',
    'ef765d03-0d40-421a-a909-fb1ea4b12815': 'Jessica Otero',
    'deb75a91-abf0-4b2a-b019-d3e4413a9381': 'John Roxburgh',
    '0884ad3e-0410-4fb5-8afb-b2e929f582fd': 'Jordon Segura',    
    '3f551c4b-3ec8-4f43-a4ee-3767e20ebee5': 'Julia Sexton',
    '7f185d7d-d877-4138-9dfd-6147cacd3620': 'Kristen Grau',
    '11a7ba20-d516-4e03-9448-e4803aaa96e1': 'Mikeala Devine',
    '718e7ebd-77b3-48f4-a34e-cba5de1f8bfd': 'Nicole Frey',
    'e9229c30-9b96-4833-bfbf-56c89bfea120': 'Parker Finot',
    '5ac4f56b-8bc1-4280-9d92-17cb46f89504': 'Robin Tippee',
    '9596521f-123f-49da-b128-2e232ad67ae3': 'Ryan Grau',
    'd9038652-f151-4b08-b426-b64d12b70394': 'Todd Fulks',
    'a5218ca6-56b0-4180-9ad7-331cb0d83a01': 'Vanessa Vigier'
};
// 'd9038652-f151-4b08-b426-b64d12b70394': 'Jeremiah Baba-Pagano',


const csvData = `
Milestones,Task Name,Owner,Responsible Party,Duration
Open Project,Create Server File & Save Engagement Agreement,Robin Tippee,SRG,1
Open Project,Set Up Client Account in QuickBooks,Robin Tippee,SRG,1
Data Gathering Form,Send Data Gathering Form to Client,Robin Tippee,SRG,1
Data Gathering Form,Call Client to Ensure Receipt of Data Gathering Form,Robin Tippee,SRG,1
Data Gathering Form,Ensure Receipt of Data Gathering Form (Follow-Ups) & Add to Folder,Robin Tippee,SRG,7
Intake Call Set-Up & Team Introduction,Send Project Overview and Intake Call Invitation to Client,Robin Tippee,SRG,1
Intake Call Set-Up & Team Introduction,Check on Status of Scheduling Intake Call,Robin Tippee,SRG,7
Intake Call,Conduct Intake Call,David Grau,SRG,0
Intake Call,Verify Project & Contact Information,David Mueller,SRG,0
Intake Call,Send Intake Call “Takeaways” Email to Client with Next Steps,David Mueller,SRG,0
Intake Call,Connect with Client on LinkedIn,David Grau,SRG,0
Deliverable Completion,Send Final Deliverables to Client ,David Grau,SRG,0
Close Project,Send Survey to Client,Parker Finot,SRG,0
Close Project,Check on Additional Billing,Parker Finot,SRG,0
Close Project,Close Project in Zoho,Parker Finot,SRG,0
Close Project,Check on Additional/Archived/On Hold Projects,Parker Finot,SRG,0
`;

const cleanCSV = (csv) => {
    const rows = csv.trim().split("\n");
    const headers = rows[0].split(",");
    const cleanedRows = rows.slice(1).map(row => {
      // Match each column using regex to handle commas within quotes
      const columns = row.match(/(".*?"|[^",]+)(?=\s*,|\s*$)/g);
      if (columns && columns.length > 1) {
        // Replace unwanted characters in the Task Name column (index 1)
        columns[1] = columns[1]
        //.replace(/,/g, "^")        // Replace commas with ^
            .replace(/'/g, `''`)   // Replace single quotes with HTML entity
            .replace(/"/g, `\"`)  // Replace double quotes with HTML entity
      }
      return columns.join(",");
    });
    return [headers.join(","), ...cleanedRows].join("\n");
}
  
  const cleanedCSV = cleanCSV(csvData);
//   console.log(JSON.stringify(cleanedCSV, null, 2));

function csvToJson(cleanedCSV) {
    const lines = cleanedCSV.trim().split('\n');
    const headers = lines[0].split(',');
    const result = [];
    const projectSteps = {};

    for (let i = 1; i < lines.length; i++) {
        const obj = {};
        const currentline = lines[i].split(',');

        for (let j = 0; j < headers.length; j++) {
            obj[headers[j]] = currentline[j];
        }

        const projectStepName = obj['Milestones'].toLowerCase().replace(/ /g, '-');
        const taskName = obj['Task Name'].toLowerCase().replace(/ /g, '-').replace(/&/g, 'and').replace(/\^/g, '').replace(/\//g, '-').replace(/--/g, '-').replace(/['"]/g, '').replace(/&#39;/g, '').replace(/&quot;/g, '').replace(/[()]/g, '').replace(/Jeremiah/g, 'todd');
        const taskLabel = obj['Task Name'].replace(/--/g, '-').replace(/Jeremiah/g, 'Todd').replace(/\^/g, ',')
        const taskInternal = true; //obj['Internal'] == 'Internal' ? true : null;
        const ownerName = obj['Owner'];
        const ownerId = Object.keys(ownerItems).find(key => ownerItems[key] === ownerName);
        const responsiblePartyName = obj['Responsible Party'];
        const responsibleParty = Object.keys(responsiblePartyItems).find(key => responsiblePartyItems[key] === responsiblePartyName);
        const duration = parseFloat(obj['Duration']).toFixed(2) || null; // Use null if duration is not found

        if (!projectSteps[projectStepName]) {
            projectSteps[projectStepName] = {
                name: projectStepName,
                label: obj['Milestones'],
                tasks: []
            };
        }

        projectSteps[projectStepName].tasks.push({
            name: taskName,
            label: taskLabel,
            parent: projectStepName,
            duration: duration,
            internal: taskInternal,
            owner_id: ownerId || null, // Use null if owner_id is not found
            task_type: "general",
            responsible_party: responsibleParty || null // Use null if responsible_party is not found
        });
    }

    for (const key in projectSteps) {
        result.push(projectSteps[key]);
    }

    return result;
}

// const finalJsonResult = {"meetings": [{"label": "Meeting 1"}, {"label": "Meeting 2"}, {"label": "Meeting 3"}, {"label": "Meeting 4"}], "projectSteps": csvToJson(cleanedCSV)};
const finalJsonResult = csvToJson(cleanedCSV);

console.log(JSON.stringify(finalJsonResult, null, 2));


// WEBPACK FOOTER //
// ./src/components/datamanagement/tempjsonbuilder.js